AoPS.StoreDatalayer = (function (StoreDatalayer) {
	StoreDatalayer.addToCart = function () {
		var dataObj = {};
		if (AoPS.bd.products && AoPS.bd.products[0]) {
			/* content_ vars used for facebook pixel add to cart tag*/
			dataObj = Object.assign(this._getTransactionBase(), {
				event: "add_to_cart",
				content_name: AoPS.bd.products[0].item_name,
				content_ids: AoPS.bd.products[0].item_id,
				content_type: AoPS.bd.products[0].item_category,
				contents: this.convertProductsToContents(),
			});
		} else {
			dataObj = Object.assign(this._getTransactionBase(), {
				event: "add_to_cart",
			});
		}
		this._push(dataObj);
	};

	StoreDatalayer.addPaymentInfo = function () {
		var dataObj = Object.assign(this._getTransactionBase(), {
			event: "add_payment_info",
			payment_type: AoPS.bd.payment_type,
		});
		this._push(dataObj);
	};

	StoreDatalayer.addShippingInfo = function () {
		var dataObj = Object.assign(this._getTransactionBase(), {
			event: "add_shipping_info",
			shipping_tier: AoPS.bd.shipping_method,
		});
		this._push(dataObj);
	};

	StoreDatalayer.beginCheckout = function () {
		var dataObj = Object.assign(this._getTransactionBase(), {
			event: "begin_checkout",
			contents: this.convertProductsToContents(),
		});
		this._push(dataObj);
	};

	StoreDatalayer.checkoutBookLicense = function () {
		var dataObj = Object.assign(this._getTransactionBase(), {
			event: "checkout_book_license",
			option: AoPS.bd.checkout_book_license,
		});
		this._push(dataObj);
	};

	StoreDatalayer.checkoutClassLicense = function () {
		var dataObj = Object.assign(this._getTransactionBase(), {
			event: "checkout_class_license",
			option: AoPS.bd.checkout_class_license,
		});
		this._push(dataObj);
	};

	StoreDatalayer.checkoutCoppaRequired = function () {
		var dataObj = Object.assign(this._getTransactionBase(), {
			event: "checkout_coppa_required",
			option: AoPS.bd.checkout_coppa_required,
		});
		this._push(dataObj);
	};

	/* used to convert gtm styled products to fbq styled contents */
	StoreDatalayer.convertProductsToContents = function (products) {
		// products may come in either an array of products or a single product
		// this should be a TODO to refactor
		if (products) {
			var contents = [];
			if (products.item_id) {
				contents.push({
					id: products.item_id,
					quantity: products.quantity,
					content_category: products.item_category,
					content_name: products.item_name,
					value: products.price,
				});
			} else {
				products.forEach(function (product) {
					contents.push({
						id: product.item_id,
						quantity: product.quantity,
						content_category: product.item_category,
						content_name: product.item_name,
						value: product.price,
					});
				});
			}
			return contents;
		}
		return null;
	};

	/* used to convert gtm styled products to enhanced ecommerce
	 * See https://www.simoahava.com/analytics/enhanced-ecommerce-guide-for-google-tag-manager/ for details
	 */
	StoreDatalayer.convertProductsToEcommerce = function (products) {
		if (products) {
			var eec = [];
			var actionField = {
				id: AoPS.bd.order.id.toString(),
				revenue: AoPS.bd.value.toString(),
				shipping: AoPS.bd.order.shipping.toString(),
				tax: AoPS.bd.order.tax.toString(),
			};
			products.forEach(function (product) {
				eec.push({
					name: product.item_name,
					id: product.item_id,
					price: product.price.toString(),
					brand: product.item_brand,
					category: product.item_category,
					variant: product.item_variant,
					quantity: product.quantity,
				});
			});
			return {
				purchase: {
					actionField: actionField,
					products: eec,
				},
			};
		}
		return null;
	};

	/*
	 * For Academy, we want to separate the summer and academic year
	 * classes because they'll have different values for Facebook.
	 * Academic Year classes should not record revenue, but summer
	 * classes should.
	 */
	StoreDatalayer.purchase = function () {
		if (
			AoPS.bd.user_info.campus_id === "web" ||
			AoPS.bd.user_info.campus_id.includes("virtual")
		) {
			var contents = this.convertProductsToContents(AoPS.bd.products);
			var dataObj = Object.assign(this._getTransactionBase(), {
				event: "purchase",
				fbValue: AoPS.bd.value,
				transaction_id: AoPS.bd.order.id,
				is_new_customer: AoPS.bd.is_new_customer,
				shipping: AoPS.bd.order.shipping,
				tax: AoPS.bd.order.tax,
				content_ids: contents ? contents.map((c) => c.id) : null,
				contents,
				ecommerce: this.convertProductsToEcommerce(AoPS.bd.products),
			});
			this._push(dataObj);
		} else {
			var summerClasses = AoPS.bd.products.filter((p) =>
				p.item_id.includes("summer")
			);
			if (summerClasses.length) {
				var summerPrice = summerClasses.reduce(function (sum, product) {
					return sum + product.price;
				}, 0);
				var summerDataObj = Object.assign({
					currency: "USD",
					items: summerClasses,
					value: summerPrice,
					fbValue: summerPrice,
					event: "purchase",
					transaction_id: AoPS.bd.order.id,
					is_new_customer: AoPS.bd.is_new_customer,
					shipping: AoPS.bd.order.shipping,
					tax: AoPS.bd.order.tax,
					contents: this.convertProductsToContents(summerClasses),
					ecommerce: this.convertProductsToEcommerce(summerClasses),
				});
				this._push(summerDataObj);
			}

			var ayClasses = AoPS.bd.products.filter(
				(p) => !p.item_id.includes("summer")
			);
			if (ayClasses.length) {
				var ayPrice = ayClasses.reduce(function (sum, product) {
					return sum + product.price;
				}, 0);
				var ayDataObj = Object.assign({
					currency: "USD",
					items: ayClasses,
					value: ayPrice,
					fbValue: 0,
					event: "purchase",
					transaction_id: AoPS.bd.order.id,
					is_new_customer: AoPS.bd.is_new_customer,
					shipping: AoPS.bd.order.shipping,
					tax: AoPS.bd.order.tax,
					contents: this.convertProductsToContents(ayClasses),
					ecommerce: this.convertProductsToEcommerce(ayClasses),
				});
				this._push(ayDataObj);
			}
		}
	};

	StoreDatalayer.subscribe = function () {
		var dataObj = {
			event: "subscribe",
		};
		this._push(dataObj);
	};

	StoreDatalayer.removeFromCart = function () {
		var dataObj = Object.assign({
			event: "remove_from_cart",
			currency: "USD",
			items: AoPS.bd.removed,
			value: AoPS.bd.removed.price,
		});
		this._push(dataObj);
	};

	StoreDatalayer.viewCart = function () {
		var dataObj = Object.assign(this._getTransactionBase(), {
			event: "view_cart",
		});
		this._push(dataObj);
	};

	StoreDatalayer.viewItem = function () {
		var dataObj = Object.assign(this._getTransactionBase(), {
			event: "view_item",
			contents: this.convertProductsToContents(AoPS.bd.products),
		});
		// products may come in either an array of products or a single product
		// this should be a TODO to refactor
		if (AoPS.bd.products) {
			if (AoPS.bd.products.item_id) {
				dataObj = Object.assign(dataObj, {
					content_name: AoPS.bd.products.item_name,
					content_ids: AoPS.bd.products.item_id,
					content_type: AoPS.bd.products.item_category,
				});
			} else {
				dataObj = Object.assign(dataObj, {
					content_name: AoPS.bd.products[0].item_name,
					content_ids: AoPS.bd.products[0].item_id,
					content_type: AoPS.bd.products[0].item_category,
				});
			}
		}
		this._push(dataObj);
	};

	StoreDatalayer.init = function () {
		if (AoPS.bd.fireAnalytics && AoPS.bd.fireAnalytics.length) {
			AoPS.bd.fireAnalytics.forEach((action) => {
				switch (action) {
					case "add_to_cart":
						this.addToCart();
						break;
					case "add_payment_info":
						this.addPaymentInfo();
						break;
					case "add_shipping_info":
						this.addShippingInfo();
						break;
					case "begin_checkout":
						this.beginCheckout();
						break;
					case "checkout_book_license":
						this.checkoutBookLicense();
						break;
					case "checkout_class_license":
						this.checkoutClassLicense();
						break;
					case "checkout_coppa_required":
						this.checkoutCoppaRequired();
						break;
					case "purchase":
						this.purchase();
						break;
					case "subscribe":
						this.subscribe();
						break;
					case "remove_from_cart":
						this.removeFromCart();
						break;
					case "view_cart":
						this.viewCart();
						break;
					case "view_item":
						this.viewItem();
						break;
					default:
						break;
				}
			});
		}
	};
	StoreDatalayer._getTransactionBase = function () {
		return {
			currency: "USD",
			items: AoPS.bd.products,
			value: AoPS.bd.value,
		};
	};

	// encapsulate the logic that makes sure the
	// data layer actually exists before each push
	StoreDatalayer._push = function (dataObj) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(dataObj);
	};

	return StoreDatalayer;
})(AoPS.StoreDatalayer || {});

AoPS.StoreDatalayer.init();
